import Grid from '@material-ui/core/Grid';
import { compact } from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';
import useSortProducts from 'src/hooks/useSortProducts';
import { useQuotationContext } from '../contexts/QuotationContext';
import { Product, ProductGroup } from '../graphql';
import ProductCard from './ProductCard';

type Props = {
  productGroups: ProductGroup[];
};

const ResultPanel = ({ productGroups }: Props) => {
  const { activeProduct, selectedVariable, setActiveProduct } =
    useQuotationContext();

  const products = useMemo(() => {
    if (productGroups.length === 1) {
      return productGroups[0].elements.map(element => element.resource);
    } else {
      return compact(
        productGroups.map(group => {
          // WARNING: This is heuristic. Should consider when multiple variables apply.
          const element = group.elements.find(el =>
            el.variable_ids.includes(selectedVariable.id),
          );
          return element?.resource;
        }),
      );
    }
  }, [productGroups, selectedVariable]);

  const sortedProducts = useSortProducts(products);
  const [touched, setTouched] = useState(false);
  useEffect(() => {
    if (!touched) {
      setActiveProduct(sortedProducts[0]);
    }
  }, [setActiveProduct, sortedProducts, touched]);

  const handleClick = useCallback(
    (newActiveProduct: Product) => {
      setActiveProduct(newActiveProduct);
      setTouched(true);
    },
    [setActiveProduct],
  );

  return (
    <Grid container spacing={2} justifyContent="space-between">
      {sortedProducts.map((product, ix) => {
        return (
          <Grid item xs={12} sm key={ix}>
            <ProductCard
              product={product}
              selected={product.code === activeProduct?.code}
              onClick={handleClick}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default ResultPanel;
